import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider, Typography} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import ObjectDefinition from '../ObjectDefinition';
import RequestDefinition from '../RequestDefinition';
import {jsonObject, memoAttributes, memosHeader} from '../../data/memos/memo';

export default new RouteComponent(`${apiRoutePrefix}/memos`, () => {
    return (
        <div>
            <ObjectHeader data={ memosHeader }>
                <Box>
                    <Typography>The following objects support memos:</Typography>
                    <ul>
                        <li><Typography>Manufacture Orders</Typography></li>
                        <li><Typography>Parts</Typography></li>
                        <li><Typography>Products</Typography></li>
                        <li><Typography>Purchase Orders</Typography></li>
                        <li><Typography>Sales Orders</Typography></li>
                        <li><Typography>Transfer Orders</Typography></li>
                        <li><Typography>Vendors</Typography></li>
                        <li><Typography>Work Orders</Typography></li>
                    </ul>
                </Box>
            </ObjectHeader>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The memo object',
                attributes: memoAttributes,
                jsonObject: jsonObject
            } }/>

            {
                memosHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data}/>
                    </>
                ))
            }

        </div>
    );
});
